import { topics } from "@/mocks/topics";
import PollCard from "@/components/base/PollCard";
import SectionHeading from "@/components/base/SectionHeading";

const topPolls = [...topics]
  .sort((a, b) => b.poll.totalVotes - a.poll.totalVotes)
  .slice(0, 3);

export default function PollSnapshot() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="投票结果展示"
          title="本周参与人数最多的三场投票"
          subtitle="每一场投票都保留完整的选项与得票比例，点一下就能投出自己的一票，结果会即时反映在进度条上。"
          linkTo="/polls"
          linkLabel="打开投票风向"
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {topPolls.map((topic) => (
            <PollCard key={topic.id} poll={topic.poll} topicTitle={topic.title} />
          ))}
        </div>
      </div>
    </section>
  );
}